import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { EButtonType } from "../../data-types/button.enum";
import { EInputStyleType } from "../../data-types/input-style.enum";
import { ETextareaStyleType } from "../../data-types/textarea-style.enum";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormControlName,
  Validators,
} from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { EInputMediaStyleType } from "../../data-types/input-media-style.enum";
import { iconsLibrary } from "../../../theme/constants";
import { NgxCSVParserError, NgxCsvParser } from "ngx-csv-parser";
import { showAlertAction } from "../../store/actions/alert.action";
import { TranslateService } from "@ngx-translate/core";
import { Store } from "@ngrx/store";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { UserService } from "../../services/user.service";
import { IAppState } from "../../store/state/app.state";
import { CompanyService } from "../../services/company.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { EStorageType } from "../../data-types/storage.enum";
import { BackofficeService } from "../../services/backoffice.service";
import { CowingSecurityEncryptService } from "../../services/cowingSecurityEncrypt.service";
import { textChangeRangeIsUnchanged } from "typescript";

var window: any;

@Component({
  selector: "cowing-core-backoffice-edit-company",
  templateUrl: "./backoffice-edit-company.component.html",
  styleUrls: ["./backoffice-edit-company.component.scss"],
})
export class BackofficeEditCompanyComponent implements OnInit {
  @Input("companyId") companyId = null;
  @Input("closeModal") closeModal;
  public EInputStyleType = EInputStyleType;
  public EButtonType = EButtonType;
  public EInputMediaStyleType = EInputMediaStyleType;
  public ready = false;
  public decodedPayment = null;
  constructor(
    private formBuilder: FormBuilder,
    private _store: Store<IAppState>,
    private localStorageService: LocalStorageService
  ) {}
  async ngOnInit() {
    console.log(this.companyId);
    this.editCompanyForm
      .get("is_business_group")
      .valueChanges.subscribe((value) => {
        const businessGroupName = this.editCompanyForm.get("business_group");

        if (value === "No" && businessGroupName.disabled === false) {
          businessGroupName.setValidators([]);
          businessGroupName.setValue("");
          businessGroupName.disable();
        } else if (value === "Si" && businessGroupName.disabled === true) {
          businessGroupName.setValidators([Validators.required]);
          businessGroupName.enable();
        }
        //
        businessGroupName.updateValueAndValidity();
      });
    await this.getCompany();
  }
  public editCompanyForm = this.formBuilder.group({
    latitude: new FormControl(null, [Validators.required]),
    longitude: new FormControl(null, [Validators.required]),
    city: new FormControl(null, [Validators.required]),
    province: new FormControl(null, [Validators.required]),
    country: new FormControl(null, [Validators.required]),
    is_business_group: new FormControl("No", []),
  });
  public paymentCompanyForm = this.formBuilder.group({});
  async getCompany() {
    try {
      this._store.dispatch(showLoadingAction({}));
      const company: Object = await BackofficeService.instance.getCompany(
        this.companyId
      );

      this.editCompanyForm.addControl(
        "business_group",
        new FormControl(company["business_group"], Validators.required)
      );
      this.editCompanyForm.addControl(
        "business_name",
        new FormControl(company["business_name"], Validators.required)
      );
      this.editCompanyForm.addControl(
        "company_name",
        new FormControl(company["company_name"], Validators.required)
      );
      this.editCompanyForm.addControl(
        "email",
        new FormControl(company["email"], Validators.required)
      );
      this.editCompanyForm.addControl(
        "fiscal_address",
        new FormControl(company["fiscal_address"], Validators.required)
      );
      this.editCompanyForm.addControl(
        "name",
        new FormControl(company["name"], Validators.required)
      );
      this.editCompanyForm.addControl(
        "phone",
        new FormControl(company["phone"], Validators.required)
      );
      this.editCompanyForm.addControl(
        "tax_id",
        new FormControl(company["tax_id"], Validators.required)
      );
      this.editCompanyForm.addControl(
        "total_cowings",
        new FormControl(company["total_cowings"], Validators.required)
      );

      company["payment_info"]
        ? this.decodePayment(company["payment_info"])
        : undefined;
      if (company["business_group"]) {
        this.editCompanyForm.get("is_business_group").setValue("Si");
      } else {
        this.editCompanyForm.get("business_group").disable();
      }

      return company;
    } catch (e) {
      console.error(e);
    } finally {
      this.ready = true;
      this._store.dispatch(closeLoadingAction({}));
    }
  }

  get formControl() {
    return this.editCompanyForm.controls;
  }

  decodePayment(paymentInfo) {
    const response = CowingSecurityEncryptService.instance.decrypt(paymentInfo);
    const decodedResponse = JSON.parse(response);
    this.decodedPayment = decodedResponse;
    for (const key in this.decodedPayment) {
      this.paymentCompanyForm.addControl(
        key,
        new FormControl({ value: this.decodedPayment[key], disabled: true }, [
          Validators.required,
        ])
      );
    }
  }
  async editCompany() {
    try {
      this._store.dispatch(showLoadingAction({}));
      const response = await BackofficeService.instance.editCompany(
        this.companyId,
        this.editCompanyForm.value
      );
      this.closeModal();
    } catch (e) {
      console.error(e);
    } finally {
      this.ready = true;
      this._store.dispatch(closeLoadingAction({}));
    }
  }
  public setLocation(currentLocation) {
    this._setLocation(currentLocation);
  }
  public _setLocation(location) {
    this.editCompanyForm.get("latitude").setValue(location.lat);
    this.editCompanyForm.get("longitude").setValue(location.lng);
    this.editCompanyForm.get("city").setValue(location.city);
    this.editCompanyForm.get("country").setValue(location.country);
    this.editCompanyForm.get("province").setValue(location.province);
  }
  public getErrors() {
    console.log(this.editCompanyForm.errors);
    return "";
  }
}
